/*
 * Author: Harper Yan
 * File Created: Wednesday, 24-07-10 02:35 pm
 * Last Modified: Wednesday, 24-11-06 03:45 pm, by Dw
 */

import { immer } from 'zustand/middleware/immer';
import { createStore } from 'zustand/vanilla';

import { MessageQueue } from '../@type.d';
import { logger, uid } from '../utils';
import { ClearFn, DestroyFn, HideFn, ShowFn } from './@types.d';

const MISSED_DIALOG_ID_ERROR_MESSAGE = '[ERROR]: Dialog ID is missing';

export type DialogState = {
  dialogQueue: MessageQueue;
  show: ShowFn;
  hide: HideFn;
  destroy: DestroyFn;
  clear: ClearFn;
};

// @ts-ignore
const store = createStore<DialogState, [['zustand/immer', never]]>(
  immer((set, get) => ({
    dialogQueue: {},
    show: (component, props, options = { destroyOnClose: true }) => {
      const id = uid(8);

      set((state) => {
        state.dialogQueue[id] = {
          component,
          props: {
            ...props,
            open: true,
          },
          options,
        };
      });

      const onClose = (id: string) => () => {
        if (options?.destroyOnClose) {
          get().destroy(id);

          return;
        }

        get().hide(id);
      };

      return onClose(id);
    },
    hide: (id) => {
      if (!get().dialogQueue[id]) {
        logger.error(MISSED_DIALOG_ID_ERROR_MESSAGE);

        return;
      }

      set((state) => {
        state.dialogQueue[id]!.props!.open = false;
      });
    },
    destroy: (id) => {
      if (!get().dialogQueue[id]) {
        logger.error(MISSED_DIALOG_ID_ERROR_MESSAGE);

        return;
      }

      set((state) => {
        delete state.dialogQueue[id];
      });
    },
    clear: () => {
      set((state) => {
        state.dialogQueue = {};
      });
    },
  }))
);

export default store;
